import script from "./Crumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./Crumb.vue?vue&type=script&setup=true&lang=ts"

import "./Crumb.vue?vue&type=style&index=0&id=eb90a8d6&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb90a8d6"]])

export default __exports__